import Waste from "../../waste/Waste";

/**
 * Parcours Flux de déchets (liste + fiche). Le routeur vit dans Waste.js
 * pour que d’anciens bundles qui importaient encore ce module utilisent
 * le même flux sans modale.
 */
const SettingsWaste = ({ token, API }) => <Waste token={token} API={API} />;

export default SettingsWaste;
